import { Injectable, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { BlockuiComponent } from './blockui/blockui.component';

@Injectable()
export class BlockUiService {
  private blockUi = [];

  constructor(private resolver: ComponentFactoryResolver) {}

  start(view: ViewContainerRef, message?: string) {
    const factory = this.resolver.resolveComponentFactory(BlockuiComponent);
    const ref = view.createComponent(factory);
    this.blockUi.push(ref);

    if (message) {
      ref.instance.message = message;
    }
  }

  stop() {
    const c = this.blockUi.pop();
    if (c) c.destroy();
  }
}
